import React from "react"
import { useTranslation } from "react-i18next"

import { Heading } from "~/components/Heading/Heading"
import { Link } from "~/components/Link/Link"
import { Raw } from "~/components/raw"

import styles from "./index.module.css"

export const Obligation: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className="container grid grid--col-12">
      <div className={styles.Head}>
        <Heading as="h2" className={styles.Title} like="h1">
          <Raw html={t("investors-and-shareholders.Obligation.Title")} />
        </Heading>
        <Link href="/investors-and-shareholders/obligation" view="arrow">
          <Raw html={t("investors-and-shareholders.Obligation.Link")} />
        </Link>
      </div>

      <div className={styles.Description}>
        <Raw html={t("investors-and-shareholders.Obligation.Text")} />
      </div>
    </div>
  )
}
